export const DATE_FORMAT_DISPLAY = 'MMM DD, YYYY';

// Static header for non-authenticated device detail requests.
// TODO: Replace key and value with actual values from backend/config.
export const NON_AUTH_HEADER = {
    'X-Non-Auth-Key': 'NON_AUTH_STATIC_KEY_PLACEHOLDER'
};